import { Toaster as Sonner, type ToasterProps } from 'sonner';

/**
 * Toaster styled to the Industrial Ticket Counter palette via shadcn tokens.
 */
export function Toaster(props: ToasterProps) {
  return (
    <Sonner
      position="top-center"
      richColors
      toastOptions={{
        classNames: {
          toast:
            'group border-border bg-card text-foreground shadow-pop font-sans rounded-lg',
          title: 'font-display font-semibold',
          description: 'text-muted-foreground',
        },
      }}
      {...props}
    />
  );
}
